module.exports = __webpack_public_path__ + "static/media/store-Tidal.5db6ddd3.svg";